// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { assert, CurriculumState } from '@microsoft/vscodeedu-api';
import { IntlShape } from 'react-intl';

/** Returns display name for a CurriculumState value. */
export function getCurriculumStateText(intl: IntlShape, value: CurriculumState) {
    switch (value) {
        case 'creating':
            return intl.formatMessage({
                defaultMessage: 'Creating',
                description: 'Curriculum state label.',
            });
        case 'updating':
            return intl.formatMessage({
                defaultMessage: 'Updating',
                description: 'Curriculum state label.',
            });
        case 'draft':
            return intl.formatMessage({
                defaultMessage: 'Draft',
                description: 'Curriculum state label.',
            });
        case 'publishing':
            return intl.formatMessage({
                defaultMessage: 'Publishing',
                description: 'Curriculum state label.',
            });
        case 'published':
            return intl.formatMessage({
                defaultMessage: 'Published',
                description: 'Curriculum state label.',
            });
        case 'unpublishing':
            return intl.formatMessage({
                defaultMessage: 'Unpublishing',
                description: 'Curriculum state label.',
            });
        case 'deleting':
            return intl.formatMessage({
                defaultMessage: 'Deleting',
                description: 'Curriculum state label.',
            });
        default:
            assert.unreachable(value, 'Unexpected curriculum state value.');
    }
}
